import React from "react";
import LeftPanel from "./Left/Left";

export { default as Top } from "./Top/Top";
export { default as Right } from "./Right/Right";
export { default as Central } from "./Central/Central";
export { default as Bottom } from "./Bottom/Bottom";

// Only re-renders if its internal logic or specific props change
export const Left = React.memo(LeftPanel); 
